module.exports = __webpack_public_path__ + "img/4-4.c2dbc22d.svg";